/*запихать расширяемый конфиг в отдельный файл и сделать alias '@environment.namespace' необходимо , чтобы избежать циркулярной зависимости*/
import { EnvironmentNamespace as CoreEnvironmentNamespace } from '@paypoint-frontend/web-core';

export enum EDeveloperProfile {
  IANTROPOV_IIS,
}

export namespace EnvironmentNamespace {
  export class Environment extends CoreEnvironmentNamespace.Environment {
    //    production: boolean = false;
    devProfile?: EDeveloperProfile;
    ngswEnabled?: boolean = true;
  }
}
